export default "__VITE_ASSET__DGoT8QN6__"